import { SHIPPING_MODEL_KEY_POINTER } from 'models/daos/shipping/constants'
import { mapValuesObjectUtil } from 'packages/src'

const SHIPPING_DOMAIN = 'shipping'
const SHIPPING_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {},
  selected: null
}

const SHIPPING_ACTION = {
  SET_DEFAULT_FALLBACK_METHOD: 'SHIPPING_SET_DEFAULT_FALLBACK_METHOD'
}

const SHIPPING_PATH = {
  ALL: `${SHIPPING_DOMAIN}.all`,
  ALL_DATA: `${SHIPPING_DOMAIN}.all.data`,
  DATA: `${SHIPPING_DOMAIN}.data`,
  SELECTED: `${SHIPPING_DOMAIN}.selected`
}
const SHIPPING_DOMAIN_MAP_KEY = SHIPPING_MODEL_KEY_POINTER
const SHIPPING_ROOT = '/shipping'
const SHIPPING_ENDPOINT = {
  GET_RATES: `${SHIPPING_ROOT}/getRates`
}

const SHIPPING_DEFAULT_INTERNATIONAL_RATE_PRICE = 15
const SHIPPING_TAX_GST = 5
const SHIPPING_TAX_PST = {
  // [COUNTRY_CA_PROVINCE.ALBERTA]: 0,
  // [COUNTRY_CA_PROVINCE.BRITISH_COLUMBIA]: 7,
  // [COUNTRY_CA_PROVINCE.MANITOBA]: 8,
  // [COUNTRY_CA_PROVINCE.NEW_BRUNSWICK]: 8,
  // [COUNTRY_CA_PROVINCE.NEWFOUNDLAND]: 8,
  // [COUNTRY_CA_PROVINCE.NORTHWEST_TERRITORIES]: 0,
  // [COUNTRY_CA_PROVINCE.NOVA_SCOTIA]: 10,
  // [COUNTRY_CA_PROVINCE.NUNAVUT]: 0,
  // [COUNTRY_CA_PROVINCE.ONTARIO]: 8,
  // [COUNTRY_CA_PROVINCE.PRINCE_EDWARD_ISLAND]: 9,
  // [COUNTRY_CA_PROVINCE.QUEBEC]: 9.975,
  // [COUNTRY_CA_PROVINCE.SASKATCHEWAN]: 5,
  // [COUNTRY_CA_PROVINCE.YUKON_TERRITORY]: 0
}

const SHIPPING_TAX_RATE = mapValuesObjectUtil(SHIPPING_TAX_PST, value => value + SHIPPING_TAX_GST)

const SHIPPING_CODES_FOR_FREE_SHIPPING = [
  'DOM-EP',
  'USA-SP-AIR',
  'INT-SP-SURF'
]

export {
  SHIPPING_DOMAIN,
  SHIPPING_ACTION,
  SHIPPING_DOMAIN_MAP_KEY,
  SHIPPING_STATE,
  SHIPPING_PATH,
  SHIPPING_ENDPOINT,
  SHIPPING_TAX_RATE,
  SHIPPING_CODES_FOR_FREE_SHIPPING,
  SHIPPING_DEFAULT_INTERNATIONAL_RATE_PRICE
}
